import { useEffect, useState } from "react";
import { fetchLearnerDashboardData } from "PlatForms/OrgLMS/Services/LearnerService/LearnerService";

const useLearnerDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const data = await fetchLearnerDashboardData(token);
        setDashboardData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { dashboardData, loading, error };
};

export default useLearnerDashboard;
